// ==============================找专家 API==============================
import { jsonPost } from '@/utils/request'

/**
 * @description  专家分类
 *
 * @export
 * @param {*} params
 */
export function querydicdatalistwizard(params) {
    return jsonPost({
        url: `pcexpert/querydicdatalistwizard`,
        params
    })

}

/**
 * @description  专家列表
 *
 * @export
 * @param {*} params
 */
export function getexpertslist(params) {
    return jsonPost({
        url: `webexpert/getexpertslist`,
        params
    })

}

/**
 * @description  专家企业简介详情
 *
 * @export
 * @param {*} params
 */
export function freightcompanydetail(params) {
    return jsonPost({
        url: `webexpert/freightcompanydetail`,
        params
    })

}

/**
 * @description  专家企业简介公司下的专家
 *
 * @export
 * @param {*} params
 */
export function getcompanyexperts(params) {
    return jsonPost({
        url: `webexpert/getcompanyexperts`,
        params
    })

}

/**
 * @description  查询客户查看专家的权限
 *
 * @export
 * @param {*} params
 */
export function getuserqueryexpertpermission(params) {
    return jsonPost({
        url: `webexpert/getuserquerypermission`,
        params
    })

}

/**
 * @description  专家简介详情
 *
 * @export
 * @param {*} params
 */
export function getexpertdetail(params) {
    return jsonPost({
        url: `webexpert/getexpertdetail`,
        params
    })

}

/**
 * @description  专家评论接口
 *
 * @export
 * @param {*} params
 */
export function getexpertmorecomment(params) {
    return jsonPost({
        url: `webexpert/getexpertmorecomment`,
        params
    })

}

/**
 * @description  专家评论保存接口
 *
 * @export
 * @param {*} params
 */
export function savecomment(params) {
    return jsonPost({
        url: `webexpert/savecomment`,
        params
    })

}

/**
 * @description  关注-取消关注 专家
 *
 * @export
 * @param {*} params
 */
export function savecollectexpert(params) {
    return jsonPost({
        url: `webexpert/savecollectexpert`,
        params
    })

}

/**
 * @description  专家  服务案列
 *
 * @export
 * @param {*} params
 */
export function getServicelist(params) {
    return jsonPost({
        url: `webexpert/getServicelist`,
        params
    })

}
